import React, { Fragment } from "react";

import { Helmet } from "react-helmet";

import NavigationBarGeneral from "../components/navigation-bar-general";
import ContactFormLight from "../components/contact-form-light";
import Footer from "../components/footer";
import "./support.css";

const Support = (props) => {
  return (
    <div className="support-container1">
      <Helmet>
        <title>Support | CashOver Pay | Help & Customer Service</title>
        <meta
          name="description"
          content="Need help with CashOver? Find answers, contact support, and get assistance with your personal, merchant, or business digital wallet anytime."
        />
        <meta
          property="og:title"
          content="Support | CashOver | Help & Customer Service"
        />
        <meta
          property="og:description"
          content="Need help with CashOver? Find answers, contact support, and get assistance with your personal, merchant, or business digital wallet anytime."
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SITE_URL}/icon.webp`}
        />
      </Helmet>

      <NavigationBarGeneral
        text={
          <Fragment>
            <span className="support-text10">CASHOVER</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="support-text11">by overlab.io</span>
          </Fragment>
        }
        rootClassName="navigation-bar-generalroot-class-name7"
      ></NavigationBarGeneral>
      <div className="support-column1">
        <div className="support-dummy"></div>
        <div className="support-column2">
          <h1 className="support-text12">
            <span className="support-text13">24/7</span>
            <span> CASHOVER SUPPORT!</span>
          </h1>
          <p className="support-text15">
            Our team is always available to assist you around the clock
          </p>
          <div className="support-row">
            <a
              href="mailto:contactus@cashover.money?subject=Support"
              className="support-action11 thq-button-outline"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                className="support-icon1"
              >
                <path
                  d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"
                  fill="currentColor"
                ></path>
              </svg>
              <span className="support-text16">EMAIL</span>
            </a>
            <a
              href="tel:+9616424108"
              className="support-action12 thq-button-outline"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 32 32"
                className="support-icon3"
              >
                <path
                  d="M26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 0 1 5.76 3h5.51a2 2 0 0 1 1.86 1.26L14.65 8a2 2 0 0 1-.44 2.16l-2.13 2.15a9.37 9.37 0 0 0 7.58 7.6l2.17-2.15a2 2 0 0 1 2.17-.41l3.77 1.51A2 2 0 0 1 29 20.72V26a3 3 0 0 1-3 3M6 5a1 1 0 0 0-1 1v.08C5.46 12 8.41 26 25.94 27a1 1 0 0 0 1.06-.94v-5.34l-3.77-1.51l-2.87 2.85l-.48-.06c-8.7-1.09-9.88-9.79-9.88-9.88l-.06-.48l2.84-2.87L11.28 5Z"
                  fill="currentColor"
                ></path>
              </svg>
              <span className="support-text17">PHONE</span>
            </a>
            <a
              href="https://wa.me/+96171083096"
              target="_blank"
              rel="noreferrer noopener"
              className="support-action13 thq-button-filled-whatsapp"
            >
              <svg viewBox="0 0 1024 1024" className="support-icon5">
                <path d="M873 148.8c-95.8-96-223.2-148.8-359-148.8-279.6 0-507.2 227.6-507.2 507.4 0 89.4 23.4 176.8 67.8 253.6l-72 263 269-70.6c74.2 40.4 157.6 61.8 242.4 61.8h0.2c0 0 0 0 0 0 279.6 0 507.4-227.6 507.4-507.4 0-135.6-52.8-263-148.6-359zM514.2 929.6v0c-75.8 0-150-20.4-214.8-58.8l-15.4-9.2-159.6 41.8 42.6-155.6-10-16c-42.4-67-64.6-144.6-64.6-224.4 0-232.6 189.2-421.8 422-421.8 112.6 0 218.6 44 298.2 123.6 79.6 79.8 123.4 185.6 123.4 298.4-0.2 232.8-189.4 422-421.8 422zM745.4 613.6c-12.6-6.4-75-37-86.6-41.2s-20-6.4-28.6 6.4c-8.4 12.6-32.8 41.2-40.2 49.8-7.4 8.4-14.8 9.6-27.4 3.2s-53.6-19.8-102-63c-37.6-33.6-63.2-75.2-70.6-87.8s-0.8-19.6 5.6-25.8c5.8-5.6 12.6-14.8 19-22.2s8.4-12.6 12.6-21.2c4.2-8.4 2.2-15.8-1-22.2s-28.6-68.8-39-94.2c-10.2-24.8-20.8-21.4-28.6-21.8-7.4-0.4-15.8-0.4-24.2-0.4s-22.2 3.2-33.8 15.8c-11.6 12.6-44.4 43.4-44.4 105.8s45.4 122.6 51.8 131.2c6.4 8.4 89.4 136.6 216.6 191.4 30.2 13 53.8 20.8 72.2 26.8 30.4 9.6 58 8.2 79.8 5 24.4-3.6 75-30.6 85.6-60.2s10.6-55 7.4-60.2c-3-5.6-11.4-8.8-24.2-15.2z"></path>
              </svg>
              <span className="support-text18">WHATSAPP</span>
            </a>
          </div>
        </div>
        <div className="support-column3">
          <span className="support-text19">
            You can also reach out to us using our contact form below
          </span>
          <div className="support-container2">
            <svg viewBox="0 0 1024 1024" className="support-icon7">
              <path d="M780.501 481.835l-225.835 225.835v-494.336c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667v494.336l-225.835-225.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l298.667 298.667c4.096 4.096 8.789 7.168 13.824 9.259s10.539 3.243 16.341 3.243c5.547 0 11.136-1.067 16.341-3.243 5.035-2.091 9.728-5.163 13.824-9.259l298.667-298.667c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"></path>
            </svg>
          </div>
        </div>
      </div>
      <ContactFormLight rootClassName="contact-form-lightroot-class-name1"></ContactFormLight>
      <Footer text4="Partner" rootClassName="footerroot-class-name4"></Footer>
    </div>
  );
};

export default Support;
